import { Text, Flex, Box, Link } from "@chakra-ui/react";
import ViewCompletion from "../../../components/guide/view-completion";
import ViewProgress from "../../../components/guide/view-progress";
import ViewQuestion from "../../../components/guide/view-question";
import LandingWelcome from "../../../components/guide/landing-welcome";
import { minHeight, useGuide } from "../../../hooks/use-guide";

export default function Quiz() {
  const {
    showWelcome,
    quizStatus,
    setQuizStatus,
    selectedUserLanguage,
    setSelectedUserLanguage,
    selectedPracticeLanguage,
    setSelectedPracticeLanguage,
    onNextStep,
    showContent,
    showProgress,
    showCompletion,
    quizQuestions,
    quizIndex,
    currentStep,
    voice,
    onReset,
    onPrevStep,
  } = useGuide();

  return (
    <Box
      backgroundSize="cover"
      backgroundRepeat={"no-repeat"}
      backgroundImage={`url('/quiz/quiz-bg.jpg')`}
      backgroundPosition="top-center"
      backgroundColor="gray.200"
      minH={"1200px"}
    >
      <Box id="quiz-scroll-target" mt="100px"></Box>
      <Flex
        id="quiz-container"
        m="0 auto"
        w="800px"
        minH={minHeight}
        maxW="calc(100% - 20px)"
        flexDir="column"
        borderRadius={10}
        p={{ base: "10px", md: 10 }}
        backgroundColor={"rgba(255,255,255,1)"}
        boxShadow={"lg"}
        position="relative"
        overflow={"hidden"}
      >
        {showWelcome && (
          <LandingWelcome
            quizStatus={quizStatus}
            setQuizStatus={setQuizStatus}
            selectedUserLanguage={selectedUserLanguage}
            setSelectedUserLanguage={setSelectedUserLanguage}
            selectedPracticeLanguage={selectedPracticeLanguage}
            setSelectedPracticeLanguage={setSelectedPracticeLanguage}
            onStart={onNextStep}
          />
        )}

        {showContent &&
          (showProgress ? (
            <ViewProgress
              questions={quizQuestions}
              quizIndex={quizIndex}
              onNext={onNextStep}
              onPrev={onPrevStep}
            />
          ) : (
            <ViewQuestion
              question={quizQuestions[quizIndex]}
              voice={voice}
              currentStep={currentStep}
              showShareButton={true}
              onNextStep={onNextStep}
              onPrevStep={onPrevStep}
            />
          ))}

        {showCompletion && <ViewCompletion onReset={onReset} />}
      </Flex>
      <Box>
        <Text fontSize="xs" color={"gray.100"} textAlign={"center"} my={10}>
          The guide is partially generated with AI. <br /> We continuously quality check, but{" "}
          <Link
            textDecor={"underline"}
            href="https://forms.gle/mDKeNg7RAj72oZsu8"
            target="_blank"
            rel="nofollow noreferrer"
          >
            please let us know
          </Link>{" "}
          if you find any errors or omissions.
        </Text>
      </Box>
    </Box>
  );
}
